export default __webpack_public_path__ + "static/media/Wordpress_Ecommerce_Home_-_Shop4myvape.d41bc9c0.png";